import { jsx } from "react/jsx-runtime";
import { c as classNames } from "../../index-CweZ_OcN.js";
import DynamicTagComponent from "../DynamicTagComponent/index.es.js";
import { Conditional } from "../Conditional/index.es.js";
import './styles.css';const Text = ({
  as = "p",
  children,
  className = "",
  color = "common",
  variant = "body-medium",
  variantDesk,
  weight = "regular",
  dangerouslySetInnerHTML,
  ...props
}) => {
  const rootClasses = classNames("au-text", {
    [`au-text--${variant}`]: !!variant,
    [`au-text--desk-${variantDesk}`]: !!variantDesk,
    [`au-text--color-${color}`]: !!color,
    [`au-text--weight-${weight}`]: !!weight,
    [className]: !!className
  });
  return /* @__PURE__ */ jsx(DynamicTagComponent, { tag: as, className: rootClasses, ...props, children: /* @__PURE__ */ jsx(
    Conditional,
    {
      condition: dangerouslySetInnerHTML,
      renderIf: /* @__PURE__ */ jsx("div", { dangerouslySetInnerHTML: { __html: dangerouslySetInnerHTML } }),
      renderElse: children
    }
  ) });
};
export {
  Text
};
//# sourceMappingURL=index.es.js.map
